export var widthMap = {
    wide: '1450px',
    mediumLarge: '1200px',
    medium: '900px',
    narrow: '600px',
    auto: 'auto',
};
